export enum DevicePlatformKind {
  Mobile = "mobile",
  Tablet = "tablet",
  Desktop = "desktop",
}
